import React from "react";
import { Page } from "../components/general/Page";
import { PageHeader } from "../components/general/PageHeader";
import { ContactList } from "../components/contact/ContactList";
import { useLanguage } from "../contexts";

const Contact = () => {
  const { t } = useLanguage();
  return (
    <Page>
      <PageHeader
        eyebrow={t("NAVIGATION.CONTACT")}
        title={t("CONTACT.TITLE")}
        subtitle={t("CONTACT.SUBTITLE")}
      />
      <ContactList />
    </Page>
  );
};

export default Contact;
